const sections = [
  {title: "Construction", link: "construction"},
  {title: "Rénovation", link: "renovation"},
  {title: "Agrandissement", link: "agrandissement"},
  {title: "Surélévation", link: "surelevation"},
];

export default sections;